import React from 'react';

import { EuiImage } from '../../../../src/components';

export default () => (
  <EuiImage
    size="l"
    hasShadow
    caption="Random nature image"
    alt="Random nature image"
    url="https://picsum.photos/300/300"
  />
);
